import React, { useContext, useEffect, useState } from "react";
import moment from "moment-timezone";
import _ from "lodash";

import { IconButton, Paper, Typography } from "@mui/material";

import { useTheme } from "@mui/material/styles";

import ZoomInIcon from "@mui/icons-material/ZoomIn";
import ZoomOutIcon from "@mui/icons-material/ZoomOut";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import CloseIcon from "@mui/icons-material/Close";
import InfoIcon from "@mui/icons-material/Info";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";

import ModelContext from "../../contexts/Model/ModelContext";

function PopupToolsMobile(props) {
  const theme = useTheme();

  const { models } = useContext(ModelContext);

  const {
    zoom,
    imageData,
    handleResetZoom,
    handleZoomIn,
    handleZoomOut,
    handleClose,
    handleShowUploadDialog,
  } = props;

  const [showInfoPanel, setShowInfoPanel] = useState(
    isProcessedImage(imageData)
  );

  const [modelName, setModelName] = useState("");

  const handleDownload = () => {
    const fileUrl = imageData.file;

    const link = document.createElement("a");
    link.href = fileUrl;
    link.download = "bcip_ml_image.jpeg";

    link.click();
  };

  useEffect(() => {
    const modelId = _.get(imageData, "model", "");
    const model = _.find(models, { _id: modelId });

    if (!model || !model.displayName) {
      setModelName("Unknown");
      return;
    }

    setModelName(model.displayName);
  }, []);

  return (
    <>
      <Paper
        style={{
          position: "fixed",
          top: 0,
          width: "100%",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-around",
          opacity: 0.9,
        }}
        onClick={() => setShowInfoPanel(!showInfoPanel)}
      >
        {showInfoPanel && (
          <div
            style={{
              margin: theme.spacing(),
              display: "flex",
              flexDirection: "column",
            }}
          >
            {imageData.model && (
              <Typography variant="caption">Model: {modelName}</Typography>
            )}
            {imageData.counts && (
              <Typography variant="caption">
                Number of Containers: {getContainersForImageData(imageData)}
              </Typography>
            )}
            {imageData.createdAt && (
              <Typography variant="caption">
                Date Processed: {formatDateForImageData(imageData)}
              </Typography>
            )}
            {!_.isNil(imageData.duration) && (
              <Typography variant="caption">
                Time to process: {`${_.round(imageData.duration, 2)}s`}
              </Typography>
            )}
          </div>
        )}
      </Paper>
      <Paper
        style={{
          position: "fixed",
          bottom: 0,
          width: "100%",
          height: "60px",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-around",
        }}
      >
        {isProcessedImage(imageData) && (
          <IconButton
            onClick={() => setShowInfoPanel(!showInfoPanel)}
            // onTouchStart={() => setShowInfoPanel(!showInfoPanel)}
            style={{ padding: 0, margin: theme.spacing(1) }}
          >
            <InfoIcon style={{ fontSize: "32px" }} />
          </IconButton>
        )}
        <IconButton
          disabled={zoom >= 4}
          onClick={handleZoomIn}
          // onTouchStart={handleZoomIn}
          style={{ padding: 0, margin: theme.spacing(1) }}
        >
          <ZoomInIcon style={{ fontSize: "32px" }} />
        </IconButton>
        <IconButton
          disabled={zoom <= 1}
          onClick={handleZoomOut}
          // onTouchStart={handleZoomOut}
          style={{ padding: 0, margin: theme.spacing(1) }}
        >
          <ZoomOutIcon style={{ fontSize: "32px" }} />
        </IconButton>
        <IconButton
          disabled={zoom === 1}
          onClick={handleResetZoom}
          // onTouchStart={handleResetZoom}
          style={{ padding: 0, margin: theme.spacing(1) }}
        >
          <FullscreenIcon style={{ fontSize: "32px" }} />
        </IconButton>
        {isUploadedImage(imageData) && (
          <IconButton
            onClick={handleShowUploadDialog}
            // onTouchStart={handleDownload}
            style={{
              padding: 0,
              margin: theme.spacing(1),
              marginLeft: theme.spacing(2),
            }}
          >
            <CloudUploadIcon style={{ fontSize: "32px" }} />
          </IconButton>
        )}
        <IconButton
          onClick={handleDownload}
          // onTouchStart={handleDownload}
          style={{
            padding: 0,
            margin: theme.spacing(1),
            marginLeft: theme.spacing(2),
          }}
        >
          <CloudDownloadIcon style={{ fontSize: "32px" }} />
        </IconButton>
        <IconButton
          onClick={handleClose}
          // onTouchStart={handleClose}
          style={{
            padding: 0,
            margin: theme.spacing(1),
          }}
        >
          <CloseIcon style={{ fontSize: "32px" }} />
        </IconButton>
      </Paper>
    </>
  );
}

export default PopupToolsMobile;

function getContainersForImageData(imageData) {
  const counts = imageData.counts;
  return _.reduce(
    counts,
    (totalContainers, count) => totalContainers + count.amount || 0,
    0
  );
}

function formatDateForImageData(imageData) {
  const date = imageData.createdAt;
  return moment(date).tz(process.env.REACT_APP_TIMEZONE).format("MMM DD, YYYY");
}

function isProcessedImage(imageData) {
  return imageData.type === "processed";
}

function isUploadedImage(imageData) {
  return imageData.type === "uploaded";
}
